var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale-banner-style"},[_vm._v("\n    to celebrate the launch of fonz 2.0, fonz coasters are now €5! "),_c('span',{staticClass:"push-to-store",on:{"click":function($event){return _vm.pushToStore()}}},[_vm._v(" buy now ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }